export default {
  methods: {
    clickToggleMode() {
      const modeActive = this.$store.getters.getNavActiveFilterRouteName;
      const modeTarget = (modeActive === 'FindNearestStations') ? 'FindRouteStations' : 'FindNearestStations';

      // Toggle back to the nearest or route mode, syncing any filter changes
      // made while on this current mode.
      const filtersActive = { ...this.$store.getters.getFilters };

      // Remove any filters that are specific to the current mode (eg, when
      // switching from route to nearest mode, we don't need to transfer over
      // the end location filter, since it doesn't exist in nearest mode).
      const filterNamesActive = this.$store.getters.getFilterNamesSpecificToScope(modeActive);
      for (let i = 0, len = filterNamesActive.length; i < len; i += 1) {
        const filterName = filterNamesActive[i];
        delete filtersActive[filterName];
      }

      // Merge any filters that are specific to the destination mode on top of
      // the current filters. This restores that mode's own filters that aren't
      // present in the current mode.
      const filtersTarget = this.$store.getters.getFiltersForScope(modeTarget);
      const filterNamesTargetOnly = this.$store.getters.getFilterNamesSpecificToScope(modeTarget);
      const filters = filtersActive;
      for (let i = 0, len = filterNamesTargetOnly.length; i < len; i += 1) {
        const filterName = filterNamesTargetOnly[i];
        const filterTargetValue = filtersTarget[filterName];
        if (filterTargetValue !== undefined) {
          filters[filterName] = filterTargetValue;
        }
      }

      // When switching from nearest to route, specially handle syncing the
      // location to the start address.
      if (modeTarget === 'FindRouteStations') {
        const location = this.$store.getters.getFilterValue('location');
        if (!filters.start && location) {
          filters.start = location;
        }
      }

      this.$router.push({
        name: modeTarget,
        query: filters,
      });
    },
  },
};
